<template>
  <custome-Dialog
    :dialog-visible.sync="dialogVisible"
    confirm-text="保存"
    title="修改得分提示配置"
    width="30%"
    :confirm-disable="false"
    @confirm="confirm"
    @close="close"
  >
    <div class="content">
      <el-form
        ref="createForm"
        :model="createForm"
        label-width="100px"
      >
        <el-form-item
          label="分数"
          prop="score"
        >
          <el-input v-model="createForm.score" />
        </el-form-item>
        <el-form-item
          label="提示语句"
          prop="scoreIntro"
        >
          <el-input v-model="createForm.scoreIntro" />
        </el-form-item>
      </el-form>
    </div>
  </custome-Dialog>
</template>
<script>
import customeDialog from '@/components/common/dialog.vue';

export default {
  name: 'ProductDialog',
  components: { customeDialog },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    item: {
      type: [Object, null],
      default: null,
    },
  },
  data() {
    return {
      cancelText: '取消',
      createForm: {
        score: '',
        scoreIntro: '',
      },
    };
  },
  watch: {
    item: {
      handler(val) {
        this.$nextTick(() => {
          if (val) {
            const {
              score,
              scoreIntro,
            } = val;
            this.createForm = {
              score,
              scoreIntro,
            };
          }
        });
      },
      deep: true,
    },
  },
  methods: {
    close() {
      console.log('close');
      this.$emit('update:dialogVisible', false);
      this.$refs.createForm.resetFields();
      this.$refs.createForm.clearValidate();
      console.log(this.createForm, 'close');
    },
    confirm() {
      this.$emit('confirm', this._.cloneDeep(this.createForm));
      this.close();
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  min-height: 200px;
}

</style>
